import { useState, useRef, useEffect } from 'react';
import throttle from 'lodash.throttle';

export const SCROLL_DIRECTION_DOWN = 'DOWN';
export const SCROLL_DIRECTION_UP = 'UP';
const THROTTLE_WAIT = 150;

/**
 *
 * @param topOffsetThreshold
 * @param bottomOffsetThreshold
 * @param scrollUpThreshold The amount of pixel after which the scroll up
 *   direction is picked up. Otherwise ignored until the threshold is reached.
 *   This is useful to keep an element hidden for a bit longer after the user
 *   starts to scroll up.
 */
export default function useScrollDirection(
  topOffsetThreshold = 0,
  bottomOffsetThreshold = 0,
  scrollUpThreshold = 400
) {
  const [scrollDirection, setScrollDirection] = useState(null);
  const lastScrollY = useRef(window.pageYOffset);
  const lastScrollUpY = useRef(window.pageYOffset);
  const lastScrollDownY = useRef(window.pageYOffset);

  useEffect(function() {
    const listener = throttle(function() {
      const scrollY = window.pageYOffset;

      if (scrollY <= topOffsetThreshold) {
        setScrollDirection(null);
      } else if (
        scrollY > window.document.body.scrollHeight - window.innerHeight - bottomOffsetThreshold
      ) {
        setScrollDirection(null);
      } else if (scrollY > lastScrollY.current) {
        setScrollDirection(SCROLL_DIRECTION_DOWN);
        lastScrollDownY.current = scrollY;
      } else if (
        scrollY < lastScrollY.current &&
        scrollY - lastScrollDownY.current < scrollUpThreshold * -1
      ) {
        setScrollDirection(SCROLL_DIRECTION_UP);
        lastScrollUpY.current = scrollY;
      }

      lastScrollY.current = scrollY;
    }, THROTTLE_WAIT);

    window.addEventListener('scroll', listener, false);

    return function() {
      window.removeEventListener('scroll', listener, false);
    }
  }, []);

  return scrollDirection;
}
